import { render } from "./SignWrapSessionView.vue?vue&type=template&id=4d271ed1&scoped=true"
import script from "./SignWrapSessionView.vue?vue&type=script&lang=js"
export * from "./SignWrapSessionView.vue?vue&type=script&lang=js"

import "./SignWrapSessionView.vue?vue&type=style&index=0&id=4d271ed1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4d271ed1"

export default script